import React, { useEffect, useState, useRef } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import styles from './Stage.module.css'

import firebase from 'firebase/app';
import 'firebase/firestore'

import TopBar from './components/TopBar/TopBar'
import BottomBar, {
    BOTTOM_BAR_HIDE,
    BOTTOM_BAR_NAVIGATION,
    BOTTOM_BAR_FINISH,
} from './components/BottomBar/BottomBar'
import {
    STAGES_DB_BY_KEY,
} from '../../../util/util'
import StageStudy from './StageStudy/StageStudy';
import StageQuiz from './StageQuiz/StageQuiz';
import StageListen from './StageListen/StageListen';
import StagePractice from './StagePractice/StagePractice';
import StageVocabulary from './StageVocabulary/StageVocabulary';
import StageText from './StageText/StageText';
import StageDialog from './StageDialog/StageDialog';
import StageAlphabet from './StageAlphabet/StageAlphabet';


import { useDispatch } from 'react-redux';
import { saveLastScore } from '../../../store/actions';
import DialogExit from './components/DialogExit/DialogExit';


const Stage = () => {

    const history = useHistory();
    const dispatch = useDispatch()
    const location = useLocation();
    const viewPagerEl = useRef();

    const [content, setContent] = useState()
    const [bottomBarMode, setBottomBarMode] = useState(BOTTOM_BAR_HIDE)
    const [maxProgress, setMaxProgress] = useState()
    const [progress, setProgress] = useState(0)

    const [isDialogExitOpen, setIsDialogExitOpen] = useState(false)

    const loadCurrStage = () => {
        firebase.firestore()
            .collection(STAGES_DB_BY_KEY[location.state.stageKey])
            .doc(location.state.lessonId)
            .get()
            .then((doc) => {
                const d = doc.data();
                switch (location.state.stageKey) {
                    case '1':
                        setMaxProgress(d.words.length + d.words.filter((word) => word.gender !== 'Neutral').length)
                        setBottomBarMode(BOTTOM_BAR_HIDE)
                        setContent(
                            <StageVocabulary
                                data={d}
                                onPageChange={(index) => setProgress(index)} />
                        )
                        break

                    case '2':
                        setMaxProgress(d.sentences.length)
                        setBottomBarMode(BOTTOM_BAR_HIDE)
                        setContent(
                            <StagePractice
                                data={d}
                                onPageChange={(index) => setProgress(index)} />
                        )
                        break;
                    case '3':
                        //DONE
                        setMaxProgress(d.text.length)
                        setBottomBarMode(BOTTOM_BAR_NAVIGATION)
                        setContent(
                            <StageStudy
                                viewPagerEl={viewPagerEl}
                                data={d}
                                onPageChange={(index) => setProgress(index)} />)
                        break;
                    case '4':
                        setMaxProgress(d.questions.length)
                        setContent(
                            <StageDialog
                                data={d}
                                onPageChange={(index) => setProgress(index)} />
                        )
                        break
                    case '5':
                        setMaxProgress(d.questions.length)
                        setContent(
                            <StageText
                                data={d}
                                onPageChange={(index) => setProgress(index)} />
                        )
                        break
                    case '6':
                        setMaxProgress(d.sentences.length)
                        setBottomBarMode(BOTTOM_BAR_FINISH)
                        setContent(
                            <StageListen
                                data={d}
                                onPageChange={(index) => setProgress(index)} />
                        )
                        break
                    case '7':
                        //DONE
                        setMaxProgress(d.questions.length)
                        setBottomBarMode(BOTTOM_BAR_HIDE)
                        setContent(
                            <StageQuiz
                                data={d}
                                onPageChange={(index) => setProgress(index)} />
                        )
                        break;
                    case '8':
                        setContent(
                            <StageAlphabet
                                data={d} />
                        )
                        break
                    default:
                        setContent(null)
                }
            })
    }

    useEffect(loadCurrStage, [])


    const onFinish = () => {
        setProgress(maxProgress);
        setTimeout(() => {
            dispatch(saveLastScore(-1))
            history.goBack();
        }, 500);
    }

    return (
        <div className={styles.container}>
            <DialogExit 
                open={isDialogExitOpen}
                onCancel={() => setIsDialogExitOpen(false)}
                onExit={() => history.goBack()}/>
            <TopBar
                progress={progress}
                maxProgress={maxProgress}
                onClose={() => setIsDialogExitOpen(true)} />
            <div style={{ height: '80px' }} />
            {content}
            <BottomBar
                onNext={() => {
                    if (viewPagerEl.current) {
                        if (progress + 1 >= maxProgress) onFinish()
                        else viewPagerEl.current.scrollTo(progress + 1)
                    }
                    if (bottomBarMode === BOTTOM_BAR_FINISH) {
                        history.goBack();
                    }
                }}
                onBack={() => {
                    if (viewPagerEl.current && progress !== 0)
                        viewPagerEl.current.scrollTo(progress - 1)
                }}
                mode={bottomBarMode}
                progress={progress}
                maxProgress={maxProgress}
            />
        </div>
    )
}

export default Stage
